module.exports = __webpack_public_path__ + "fonts/bold.2c797d09.woff2";